module.exports = __webpack_public_path__ + "static/media/ad-covid.bc65748c.png";